export enum DateType {
   Day = 0,
   Weekly = 1,
   Monthly = 2,
   Yearly = 3,
}
